module.exports = __webpack_public_path__ + "static/media/YF84_4.2ef93778.jpg";